"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.atom = void 0;
const createColorScheme_1 = require("../createColorScheme");
exports.atom = (0, createColorScheme_1.createColorScheme)("atom", {
    bg: "#282c34",
    fg: "#b0b7c2",
    primary: "#2490E9",
    secondary: "#D43542",
}, {
    red: "#E06C75",
    green: "#98C379",
    yellow: "#E5C07B",
    blue: "#61AFEF",
    purple: "#C678DD",
    cyan: "#56B6C2",
    orange: "#FFBB7C",
});
